import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import ExerciseController from '../components/exercises/ExerciseController';
import angerManagementData from '../content/anger_management.json';
import './EjercicioEnojoScreen.css';

const EjercicioEnojoScreen = () => {
  const { id } = useParams();
  const [exerciseData, setExerciseData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadExerciseData = () => {
      try {
        // Buscar el ejercicio en el JSON por ID
        const exercise = angerManagementData.find(ex => ex.id === id);
        
        if (exercise) {
          setExerciseData(exercise);
        } else {
          setError('Ejercicio no encontrado');
        }
      } catch (err) {
        setError('Error al cargar el ejercicio');
        console.error('Error loading exercise:', err);
      } finally {
        setLoading(false);
      }
    };

    loadExerciseData();
  }, [id]);

  if (loading) {
    return (
      <div className="ejercicio-enojo-screen">
        <Header />
        <div className="ejercicio-enojo-content">
          <div className="loading">Cargando ejercicio...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="ejercicio-enojo-screen">
        <Header />
        <div className="ejercicio-enojo-content">
          <h1>Error</h1>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  if (!exerciseData) {
    return (
      <div className="ejercicio-enojo-screen">
        <Header />
        <div className="ejercicio-enojo-content">
          <h1>Ejercicio no encontrado</h1>
          <p>El ejercicio solicitado no existe.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="ejercicio-enojo-screen">
      <Header />
      <ExerciseController exerciseData={exerciseData} />
    </div>
  );
};

export default EjercicioEnojoScreen; 